import {useSelector} from 'react-redux';
import {ParkingTypes} from 'common/marketing-metas';

const useOpengraphDescription = marketingMetasType => {
    const {
        opengraph_description: openGraphDescription,
        opengraph_description_transient: openGraphDescriptionTransient,
        opengraph_description_monthly: openGraphDescriptionMonthly,
    } = useSelector(state => state.page);

    let description = '';

    if (marketingMetasType === ParkingTypes.Transient) {
        description = openGraphDescriptionTransient;
    } else if (marketingMetasType === ParkingTypes.Monthly) {
        description = openGraphDescriptionMonthly;
    }

    return description || openGraphDescription;
};

export default useOpengraphDescription;
